import styled from "styled-components";

const HorizontalRule = styled.hr`
  background-color: ${props => props.theme.primary};
  height: 1px;
  margin: ${props => props.margin || "1.5rem 0"};
`;

export default HorizontalRule;
